<template>
    <div class="course_info">
        <div class="course_title_type_div">
            <div style="float: left">
                <h4>
                <span class="course_title_span">
                    {{ course_info.name }}
                </span>
                    <span class="course_type_span"
                          :class="course_type_class[course_info.fee_type]">
                    {{ course_name_type[course_info.fee_type] }}
                </span>
                </h4>
            </div>

            <div style="float: right" v-if="course_info.clock_opened">
                <el-button type="primary" @click="ready_clock">打卡</el-button>
            </div>
            <el-dialog title="打卡" :modal-append-to-body='false' :visible.sync="dialogFormVisible" width="30%">
                <CKEditor @text="get_content"></CKEditor>
                <!--<el-form :model="form" ref="form" :rules="rules">-->
                <!--<el-form-item label="真实姓名" :label-width="formLabelWidth" prop="realname">-->
                <!--<el-input v-model="form.realname" autocomplete="off"></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="手机号" :label-width="formLabelWidth" prop="phone">-->
                <!--<el-input v-model="form.phone" autocomplete="off"></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="单位名称" :label-width="formLabelWidth" prop="company">-->
                <!--<el-input v-model="form.company" autocomplete="off"></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="岗位名称" :label-width="formLabelWidth" prop="job">-->
                <!--<el-input v-model="form.job" autocomplete="off"></el-input>-->
                <!--</el-form-item>-->
                <!--<el-form-item label="微信号" :label-width="formLabelWidth">-->
                <!--<el-input v-model="form.wechat_number" autocomplete="off"></el-input>-->
                <!--</el-form-item>-->
                <!--</el-form>-->
                <div slot="footer" class="dialog-footer">
                    <el-button @click="dialogFormVisible = false">取消</el-button>
                    <el-button type="primary" @click="do_clock">确定</el-button>
                </div>
            </el-dialog>

        </div>
        <div class="course_numbers_div">
            <span v-if="course_info.online_type=='online_public'" style="color: #59cf4a;margin-right: 5px">线上课程</span>
            <span v-if="course_info.online_type=='online_quality'" style="color: #ffc500;margin-right: 5px">线上精品</span>
            <span v-if="course_info.online_type=='online_live'" style="color: #28d7f6;margin-right: 5px">线上直播</span>
            <span v-if="course_info.online_type=='symposium'" style="color: #ea5e00;margin-right: 5px">研讨课程</span>
            <span v-if="course_info.online_type=='offline_public'" style="color: #23419a;margin-right: 5px">线下课程</span>
            <span v-if="course_info.online_type=='offline_quality'" style="color: #9a2edc;margin-right: 5px">线下精品</span>
            <span v-if="course_info.online_type=='offline_salon'" style="color: #ea0094;margin-right: 5px">线下沙龙</span>
            <span class="course_numbers_line">
            </span>
            <p class="course_numbers_p">{{ course_info.students_count}} 人学过</p>
            <span class="course_numbers_line">
            </span>
            <p class="course_numbers_p"> {{ course_info.followers_count}} 人收藏</p>
            <span class="course_numbers_line">
            </span>
            <p class="course_numbers_p">
                主讲: {{ course_info.teacher.name }}
            </p>
        </div>

        <!-- 更新后下面不需要了 -->
        <div class="course_operation_div">
            <!-- 包括一些价格表和具体的开始实验按钮等 -->
            <div class="course_description">
                <div v-if="course_info.description" v-html="course_info.description.replace(/\n/g,'<br/>')"></div>
            </div>
        </div>
    </div>
</template>
<script type="text/javascript">
    import {mapState, mapActions} from 'vuex'
    import clockApi from '@/api/clock/clock.js'
    import CKEditor from '@/components/common_components/ckeditor/ckeditor.vue'

    export default {
        data() {
            return {
                course_type_class: {
                    'free': 'free_course_p',
                    'member': 'vip_course_p',
                    'bootcamp': 'training_course_p',
                    '': ''
                },
                course_name_type: {
                    'free': '免费',
                    'member': '会员',
                    'bootcamp': '训练营'
                },
                dialogFormVisible: false,
                content: ''
            }
        },
        components: {
            CKEditor,
        },
        computed: {
            ...mapState({
                course_info: state => state.course.course_information,
                sign_on: state => state.loginState.sign_on
            })
        },
        methods: {
            ...mapActions({
                change_show_state: 'loginState/change_show_state',
            }),
            get_content: function (content) {
                this.content = content
            },
            ready_clock() {
                if (!this.sign_on) {
                    this.change_show_state('on')
                } else {
                    this.dialogFormVisible = true
                }
            },
            do_clock() {
                clockApi.do_clock({'course_id': this.course_info.id, 'content': this.content}).then(res => {
                    console.log(res)
                    let data = JSON.parse(res.data.result);
                    if (data.code === 'success') {
                        this.$message({
                            type: 'success',
                            message: data.message
                        });
                        this.dialogFormVisible = false
                    } else {
                        this.$message({
                            type: 'warning',
                            message: data.message
                        });
                    }
                })
            }
        }
    }
</script>
<style type="text/css" scoped>

    >>> .ck-content {
        height: 320px !important;
    }

    .course_info {
        display: flex;
        flex-direction: column;
        border: 1px solid #eee;
        padding: 30px;
        background: #fff;
    }

    /* 课程最上部的 title 和 type 区域 */
    .course_title_type_div {
        /*display: flex;*/
    }

    .course_title_span {
        font-size: 21px;
        font-weight: 500;
    }

    /* course_type css设计 */
    .course_type_span {
        display: inline-block;
        line-height: 1.6;
        color: #fff;
        padding: 0 6px;
        border-radius: 73px;
        font-size: 13px;
        margin-left: 8px;
    }

    .free_course_p {
        background: #80c269;
    }

    .training_course_p {
        background: #f66e6e;
    }

    .vip_course_p {
        background: #ffae0f;
    }

    /* 课程的参与人数 */
    .course_numbers_div {
        display: flex;
        margin-top: 10px;
    }

    .course_numbers_p {
        margin-right: 10px;
        font-size: 14px;
        color: #a4a4a4;
    }

    .course_numbers_line:before {
        content: "";
        display: inline-block;
        height: 30px;
        width: 1px;
        background: #eee;
        margin: 0 8px -9px 4px;
    }

    /* 课程操作部分的一些信息，包括说明和按钮 */
    .course_operation_div {
        display: flex;
        flex-direction: column;
    }

    .course_buttons {
        margin-top: 20px;
    }

    .course_description {
        font-size: 15px;
        color: #4c5157;
        margin-bottom: 20px;
    }

    .start_course_button {
        background: #66CCFF;
        outline: 0;
        color: #fff;
        font-size: 16px;
        padding: 10px 78px;
        border-radius: 4px;
    }

    .start_course_button:hover {
        background: #21d6a8;
        color: #fff;
    }

    .start_course_button:active {
        background: #09ae84;
        color: #fff;
    }

</style>
